import { render } from "./IconHeartOutline80px.vue?vue&type=template&id=65bbaa18"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__